<template>
    <div class="container">
        <top-bar ref="topBar" ></top-bar>
        <!-- banner -->
        <div class="banner">
            <img style="width:100%" src="@/assets/image/services/banner.jpeg" alt="">
        </div>
        <!-- 面包屑 -->
        <div class="bread">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item class="p_bread"><a href="https://www.wch.cn/">首页</a></el-breadcrumb-item>
            <el-breadcrumb-item>服务支持</el-breadcrumb-item>
            <el-breadcrumb-item>{{activeMenu.asideName}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <!-- 内容 -->
        <div class="main" >
          <el-row :gutter="0" style="width:100%">
            <el-col :xs="24" :sm="24" :md="6" :lg="5" :xl="4" style="padding:0px;">
           
              <side-bar ref="sideBar" :style="{width:isMoPhone?'100%':'93%', marginBottom:isMoPhone?'15px':'0px'}" v-loading="loading" 
                :asideList="asideList" :activeMenu="activeMenu" @currentAside = currentAside>
              </side-bar>
            </el-col>
            <el-col :xs="24" :sm="24" :md="18" :lg="19" :xl="20" style="padding:30px;background:#fff;">
                <keep-alive >
                    <router-view :key="viewKey"/>
                </keep-alive>
            </el-col>
          </el-row>
        </div>
        <!-- 底部 -->
        <footer-part ref="footerPart"></footer-part>
    </div>
</template>
<script>
import topBar from '@/pages/topbar.vue'
import footerPart from '@/pages/components/footer.vue'
import sideBar from '@/pages/components/sidebar'
export default {
  name: "aboutUs",
  components:{
    topBar,
    footerPart,
    sideBar,
  },
  data() {
    return {
        windowWidth:window.innerWidth,
        isMoPhone:false,
        activeMenu:{},
        asideList:[
          {
            asideName:'服务支持',
            childList:[
              {key:'1', asideName:'样品索取', path:'/services/request_sample.html'},
              {key:'2', asideName:'资料下载', path:'/downloads/category/27.html'},
              {key:'3', asideName:'技术支持', path:'/services/technical_support.html'},
              {key:'4', asideName:'销售服务', path:'/services/sale_support.html'},
              // {key:'5', asideName:'工程变更通知', path:'/engineering_change_notification.html'},
            ]
          }
        ],
        loading:false,
        content:'',
        newItem:{},
    };
  },
  computed: {
    viewKey() {
       return this.$route.path
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    windowWidth(newWidth, oldWidth) {
      if (newWidth < 992) {
        this.isMoPhone = true
      }else{
        this.isMoPhone = false
      }
    },
  },
  mounted() {
    console.log('mounted--',this.$route.path)
    if (this.windowWidth < 992) {
      this.isMoPhone = true
    }else{
      this.isMoPhone = false
    }
    if(this.$route.name=='Services'){
      this.activeMenu = {key:'4', asideName:'销售服务', path:'/services/sale_support.html'}
    }else if(this.$route.name=='BuyProcess'){
      this.activeMenu = {key:'6', asideName:'购买流程', path:'/services/buy_process.html'}
    }else{
      for(let item of this.asideList[0].childList){
        if(item.path == this.$route.path){
          this.activeMenu = item
          break
        }
      }
    }
    this.$nextTick(()=>{
      this.currentAside(this.activeMenu)
    })
  },
  activated(){
    console.log('activated')
    if(this.$route.name=='Services'){
      this.activeMenu = {key:'4', asideName:'销售服务', path:'/services/sale_support.html'}
    }else if(this.$route.name=='BuyProcess'){
      this.activeMenu = {key:'5', asideName:'购买流程', path:'/services/buy_process.html'}
    }else{
      for(let item of this.asideList[0].childList){
        if(item.path == this.$route.path){
          this.activeMenu = item
          break
        }
      }
    }
    this.$nextTick(()=>{
      this.currentAside(this.activeMenu)
    })
  },
  methods:{
    handleResize() {
      this.windowWidth = window.innerWidth
    },
    //点击侧边栏
    currentAside(item){
      console.log('点击的menu',item)
      this.activeMenu = item
      document.title = this.activeMenu.asideName+' - 南京沁恒微电子股份有限公司'
      this.$router.push({ path: item.path,})
    },
   
   
    
  }
};
</script>
<style scoped>
 .container{
    width: 100%;
    margin: 0 auto;
    margin-top: 98px;
    overflow: auto;
 }
 .bread{
    width: 80%;
    margin: 0 auto;
    margin-top: 10px;
    display: flex;
    font-size: 18px;
 }
 .p_bread .el-breadcrumb__inner a, /deep/.el-breadcrumb__inner.is-link{
    color: #337ab7;
 }
 .main {
    width: 80%;
    margin: 0 auto;
    margin-top: 20px;
    /* box-shadow: 6px 6px 12px rgb(0 0 0 / 18%); */
    border-radius: 4px;
 }

</style>